import { MergeAssignmentRequestSchema, MergeAssignmentResponseSchema } from './merge-assignment.schema';
/**
 * Merge Assignment Endpoint Contract
 * Merges a pending assignment into an existing completed step recording
 */ export const mergeAssignmentContract = {
    method: 'POST',
    path: '/api/v2/process-step-assignment/:assignmentId/merge',
    description: 'Merge a pending assignment into an existing completed step',
    requestSchema: MergeAssignmentRequestSchema,
    responseSchema: MergeAssignmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Assignment not found, already completed, or target ineligible',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user cannot merge this assignment'
        }
    }
};

//# sourceMappingURL=merge-assignment.contract.js.map